export enum USER_ROLES {
    superAdmin = "super-admin",
    owner = "owner",
    admin = "admin",
    user = "user"
}

export enum BANKS {
    cbe = "cbe",
    telebirr = "telebirr",
    boa = "boa"
}

export enum VERIFICATION_STATUS {
    pending = "pending",
    verified = "verified",
    rejected = "rejected",
    failed = "failed"
}

export enum PAYMENT_CURRENCY {
    ETB = "ETB",
    USD = "USD"
}

// Human-friendly labels for the banks supported by the verifier.
export const BANK_LABELS: Record<string, string> = {
    [BANKS.cbe]: "CBE",
    [BANKS.telebirr]: "telebirr",
    [BANKS.boa]: "Bank of Abyssinia",
};
